import { createAction } from '../../helpers/general';
import { MAIN_TYPES } from '../actionTypes';

const { GLOBAL_LOADER_SHOW, GLOBAL_LOADER_HIDE } = MAIN_TYPES;

export const showGlobalLoader = createAction(GLOBAL_LOADER_SHOW);
export const hideGlobalLoader = createAction(GLOBAL_LOADER_HIDE);
